import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment as env } from '@env';


@Injectable({
  providedIn: 'root'
})
export class InventoryService {
  #baseUrl = `${env.PROTECTED_URIS["DEMOAPP"]}/v1/storage`;
  #http: HttpClient = inject(HttpClient);


  // Upload blob content as plain text (string)
  uploadBlob$<T>(containerName: string, blobName: string, content: T, overwrite: boolean = false): Observable<object> {
    const url = `${this.#baseUrl}/upload/${encodeURIComponent(containerName)}/${encodeURIComponent(blobName)}`;
    const params = new HttpParams().set('overwrite', overwrite.toString());
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    // Server expects string content in body
    return this.#http.post(url, content, { params, headers });
  }

  // Download blob content as text
  downloadBlob$(containerName: string, blobName: string): Observable<string> {
    const url = `${this.#baseUrl}/download/${encodeURIComponent(containerName)}/${encodeURIComponent(blobName)}`;

    // We expect a plain text response (not JSON)
    // You can also observe full response if you want to access headers
    return this.#http.get(url, { responseType: 'text' });
  }
}
